import { render } from "./OfferList.vue?vue&type=template&id=982a26ec&scoped=true"
import script from "./OfferList.vue?vue&type=script&lang=js"
export * from "./OfferList.vue?vue&type=script&lang=js"

import "./OfferList.vue?vue&type=style&index=0&id=982a26ec&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-982a26ec"

export default script